/**
 * Per-referral greeting, triggered by the `?source=` query parameter
 * (e.g. /?source=linkedin).
 *
 * The classic site shows `message` in a speech bubble and points at
 * `highlightTarget`. The Windows desktop shows `toast` as a notification whose
 * button opens `target` — a key in QUICK_FILES (see win11/fs.js).
 */
export const SOURCE_WELCOME_CONFIG = {
  twitter: {
    message: "hey, friend from twitter — send me an email",
    highlightTarget: "#contact-email",
    pointerPosition: "above",
    toast: {
      title: "Friend from X",
      message: "Hey — glad you made the jump. My details are in Contact.txt.",
      action: "Open Contact.txt",
      target: "contact",
    },
  },
  linkedin: {
    message:
      "hey recruiter — thanks for stopping by. grab my resume, i'd love to chat.",
    highlightTarget: "#download-resume",
    pointerPosition: "below",
    toast: {
      title: "Hey recruiter",
      message: "Thanks for stopping by. Resume.pdf is on the desktop.",
      action: "Open Resume.pdf",
      target: "resume",
    },
  },
  github: {
    message: "hey, fellow dev — check out my projects",
    highlightTarget: "#projects-section",
    pointerPosition: "above",
    toast: {
      title: "Hey, fellow dev",
      message: "Project shortcuts live in Documents \\ Projects.",
      action: "Open Projects",
      target: "projects",
    },
  },
  devto: {
    message:
      "hey, reader — glad you stopped by, send me an email or check my work.",
    highlightTarget: "#contact-email",
    pointerPosition: "above",
    toast: {
      title: "Hey, reader",
      message: "Glad you stopped by. Start with Read me first.txt.",
      action: "Open Read me first.txt",
      target: "readme",
    },
  },
  referral: {
    message: "someone thought we should connect — nice to meet you. say hi.",
    highlightTarget: "#contact-email",
    pointerPosition: "above",
    toast: {
      title: "Nice to meet you",
      message: "Someone thought we should connect — say hi.",
      action: "Open Contact.txt",
      target: "contact",
    },
  },
};

export default SOURCE_WELCOME_CONFIG;
